import Model from './Model'
import User from './User'

export default class KintellGroup extends Model {
  resource () {
    return 'kintell-groups'
  }

  get link () {
    return '/g/' + this.slug
  }

  get secondaryLogo () {
    return this.secondaryLogoUrl ? this.secondaryLogoUrl : this.logoUrl
  }

  // relations
  members () {
    return this.hasMany(User)
  }

  requestAccess (data) {
    return this.action('request-access', data)
  }

  join () {
    return this.action('join')
  }

  fetchMembers (pagination) {
    return KintellGroup
      .pagination(pagination)
      .custom(this, 'members')
      .$get()
  }
}
